
import React from 'react';
import { Modal, Carousel, Typography, Divider, Row, Col, Tag, Card, Collapse } from 'antd';
import { FaBed, FaChevronLeft, FaChevronRight, FaParking, FaUtensils, FaWifi } from 'react-icons/fa';
import moment from 'moment';

import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import { MdLocalOffer } from 'react-icons/md';


const RoomDetailsModalTripjack = ({ open, onClose, roomData, hotelDetails }) => {
    const ris = roomData?.ris?.[0];
    const roomImages = ris?.imgs?.filter((img) => img?.sz === 'XXL') || [];
    const roomTitle = ris?.rc || '';
    const roomDescription = ris?.des || '';
    const { Text, Title } = Typography;
    const facilities = ris?.fcs || [];
    const arrowStyle = {
        fontSize: '24px',
        color: '#727171',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: '1',
        background: '#fff',
        borderRadius: '50px',
        width: '28px',
        height: '28px'
    };

    const Arrow = ({ type, onClick }) => {
        if (type === 'left') {
            return <FaChevronLeft style={{ ...arrowStyle, left: '6px' }} onClick={onClick} />;
        } else if (type === 'right') {
            return <FaChevronRight style={{ ...arrowStyle, right: '6px' }} onClick={onClick} />;
        }
        return null;
    };

    const getBenefitIcon = (benefit) => {
        if (benefit.includes('Breakfast')) return <FaUtensils className="me-2" />;
        if (benefit.includes('parking')) return <FaParking className="me-2" />;
        if (benefit.includes('Wi-Fi')) return <FaWifi className="me-2" />;
        if (benefit.includes('Free WiFi')) return <FaWifi className="me-2" />;
        return <MdLocalOffer className="me-2" />;
    };

    // const bedConfig = ris?.rt?.includes('-') ? rt?.split('-')[1].trim() : "Standard Bed";
    const maxGuests = ris?.adt + ris?.chd;

    const getMealBasisExplanation = (mealCode) => {
        const explanations = {
            'ROOM ONLY': 'No meals included',
            'BREAKFAST': 'Includes breakfast',
            'HALF BOARD': 'Includes breakfast and dinner',
            'FULL BOARD': 'Includes all meals (breakfast, lunch, dinner)',
            'ALL INCLUSIVE': 'Includes all meals and selected beverages'
        };
        return explanations[mealCode] || 'Meal information not specified';
    };

    const CancellationPolicy = (() => {
        const pd = roomData?.cnp?.pd;
        if (!pd || pd.length === 0) return null;

        const first = pd[0];
        const second = pd[1];
        const last = pd[pd.length - 1];

        return (
            <div className="pb-4">
                {roomData?.cnp?.ifra ? (
                    <>
                        <h3 className="mb-2 mt-3">Cancellation Policy</h3>
                        <div className="cancellation-policy-container mb-5">
                            <ul className="cancel-summary list-unstyled my-2">
                                <li>
                                    ✅ Free Cancellation till{' '}
                                    {moment(first.tdt).format('DD MMM, hh:mm A')}
                                </li>
                                <li>
                                    ✅ No refund if cancelled after{' '}
                                    {moment(second.fdt).format('DD MMM, hh:mm A')}
                                </li>
                            </ul>

                            <div className="refund-timeline mt-3">
                                {/* Left: 100% Refund */}
                                <div className="timeline-segment left-segment">
                                    <div className="circle">
                                        <div className="tooltip">
                                            <strong>From:</strong>{' '}
                                            {moment(first.fdt).format('MMM DD, YYYY hh:mm A')}
                                            <br />
                                            <strong>To:</strong>{' '}
                                            {moment(first.tdt).format('MMM DD, YYYY hh:mm A')}
                                            <br />
                                            <span className="mt-1 d-inline-block">
                                                <strong>Charge:</strong> ₹{first.am?.toFixed(2) || 0}
                                                {first.pp ? <> ({first.pp}% of total)</> : null}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="label-top">100% Refund</div>
                                    <div className="label-bottom">
                                        <strong>NOW</strong>
                                    </div>
                                </div>

                                {/* Center Timeline Marker */}
                                <div className="timeline-center">
                                    <div className="center-line"></div>
                                    <div className="center-date">
                                        <strong>{moment(second.fdt).format('DD MMM')}</strong>
                                        <br />
                                        {moment(second.fdt).format('hh:mm A')}
                                    </div>
                                </div>

                                {/* Right: Non Refundable */}
                                <div className="timeline-segment right-segment">
                                    <div className="circle">
                                        <div className="tooltip">
                                            <strong>From:</strong>{' '}
                                            {moment(second.fdt).format('MMM DD, YYYY hh:mm A')}
                                            <br />
                                            <strong>To:</strong>{' '}
                                            {moment(last.tdt).format('MMM DD, YYYY hh:mm A')}
                                            <br />
                                            <span className="mt-1 d-inline-block">
                                                <strong>Charge:</strong> ₹{last.am?.toFixed(2) || 0}
                                                {last.pp ? <> ({last.pp}% of total)</> : null}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="label-top label-yellow">Non Refundable</div>
                                    <div className="label-bottom">
                                        <strong>{moment(last.tdt).format('DD MMM')}</strong>
                                        <br />
                                        <span className="small">Check-in</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ul className="cancel-summary list-unstyled">
                            <li className="text-muted">
                                Free Cancellation (100% refund) if you cancel this booking before{' '}
                                {moment(second.fdt).format('DD MMM, hh:mm A')}
                            </li>
                            <li className="text-muted">
                                Cancellations are only allowed before the Check-In Time. All time mentioned above is in Destination Time.
                            </li>
                        </ul>
                    </>
                ) : (
                    <>
                        <h3 className="mb-2 mt-3">Cancellation Policy</h3>
                        <Text type="secondary">No refund available for this booking.</Text>
                    </>
                )}
            </div>
        );
    })();

    return (
        <>
            <Modal
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={open}
                footer={null}
                onCancel={onClose}
                centered
                width={750}
                destroyOnClose
                className='room-details-modal'
            >
                <div className='room-details-cntr d-md-flex align-items-center gap-3 mb-md-3'>
                    {roomImages.length > 0 && (
                        <div style={{ width: '300px', height: '300px' }}>
                            <Carousel
                                arrows
                                infinite
                                effect="fade"
                                prevArrow={<Arrow type="left" />}
                                nextArrow={<Arrow type="right" />}
                                className="custom-carousel"
                            >
                                {roomImages?.map((img, index) => (
                                    <div key={index} className="w-100">
                                        <img
                                            loading="lazy"
                                            src={img.url}
                                            alt={`Room ${index}`}
                                            style={{ width: '100%', height: '300px', objectFit: 'cover' }}
                                        />
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    )}
                    <div div className='mb-md-0 mb-3'>
                        <h2 className='mb-2 pe-5'>{roomTitle}</h2>
                        {roomDescription && <><h4 className="mt-4 mb-2" p>About the room</h4>  <p>{roomDescription}</p></>}

                        <div className='bg-gray d-flex align-items-center gap-md-4 gap-3 mt-4'>
                            <p className="d-flex align-items-center gap-2 m-0 fw-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.00001C6.93913 4.00001 5.92172 4.42144 5.17157 5.17159C4.42143 5.92173 4 6.93915 4 8.00001C4 9.06088 4.42143 10.0783 5.17157 10.8284C5.92172 11.5786 6.93913 12 8 12C9.06087 12 10.0783 11.5786 10.8284 10.8284C11.5786 10.0783 12 9.06088 12 8.00001C12 6.93915 11.5786 5.92173 10.8284 5.17159C10.0783 4.42144 9.06087 4.00001 8 4.00001ZM6 13C4.93913 13 3.92172 13.4214 3.17157 14.1716C2.42143 14.9217 2 15.9391 2 17V18C2 18.5304 2.21071 19.0392 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0392 14 18.5304 14 18V17C14 15.9391 13.5786 14.9217 12.8284 14.1716C12.0783 13.4214 11.0609 13 10 13H6ZM13.25 10.905C13.728 10.045 14 9.05501 14 8.00001C14.0002 6.98345 13.7421 5.9835 13.25 5.09401C13.8178 4.55674 14.5306 4.19763 15.3003 4.06104C16.07 3.92446 16.8628 4.0164 17.5808 4.3255C18.2988 4.6346 18.9106 5.14731 19.3403 5.80026C19.7701 6.45322 19.9992 7.2178 19.9992 7.99951C19.9992 8.78123 19.7701 9.54581 19.3403 10.1988C18.9106 10.8517 18.2988 11.3644 17.5808 11.6735C16.8628 11.9826 16.07 12.0746 15.3003 11.938C14.5306 11.8014 13.8178 11.4423 13.25 10.905ZM15.466 20C15.806 19.412 16.001 18.729 16.001 18V17C16.0028 15.5238 15.4586 14.099 14.473 13H18C19.0609 13 20.0783 13.4214 20.8284 14.1716C21.5786 14.9217 22 15.9391 22 17V18C22 18.5304 21.7893 19.0392 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H15.466Z" fill="black" />
                                </svg>
                                Max  {maxGuests} {maxGuests === 1 ? 'Guest' : 'Guests'}
                            </p>
                            {/* <p className='d-flex align-items-center gap-2 m-0 fw-bold w-100'><FaBed className='fs-4' /> <span> {ris?.radi?.bds?.[0]?.bt || 'Standard'} bed</span></p> */}
                            <p className='d-flex align-items-center gap-2 m-0 fw-bold w-100'><FaBed className='fs-4' /> <span> {ris?.rt?.includes('-') ? ris?.rt?.split('-')[1].trim() : "Standard Bed"}</span></p>
                        </div>
                    </div>



                </div>

                <h3 className="mb-2">Room Amenities</h3>
                {facilities?.length > 0 && (
                    <div className="mb-4">
                        <Row gutter={[0, 8]}>
                            {facilities.map((facility, index) => (
                                <Col key={index} span={24}>
                                    <div className="d-flex align-items-center">
                                        {getBenefitIcon(facility)}
                                        <Text className="ms-2">{facility}</Text>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )}

                <h3 className="mb-2">
                    {getMealBasisExplanation(ris?.mb)}
                </h3>

                <span className="meal-basis d-block text-muted">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M12.375 5.20312C12.2227 5.20312 12.0908 5.14746 11.9795 5.03613C11.8682 4.9248 11.8125 4.79297 11.8125 4.64062C11.8125 4.3418 11.8682 4.05469 11.9795 3.7793C12.0908 3.50391 12.2549 3.26074 12.4717 3.0498L13.166 2.34668C13.3887 2.12402 13.5 1.85742 13.5 1.54688C13.5 1.39453 13.5557 1.2627 13.667 1.15137C13.7783 1.04004 13.9102 0.984375 14.0625 0.984375C14.2148 0.984375 14.3467 1.04004 14.458 1.15137C14.5693 1.2627 14.625 1.39453 14.625 1.54688C14.625 1.8457 14.5693 2.13281 14.458 2.4082C14.3467 2.68359 14.1826 2.92676 13.9658 3.1377L13.2715 3.84082C13.0488 4.06348 12.9375 4.33008 12.9375 4.64062C12.9375 4.79297 12.8818 4.9248 12.7705 5.03613C12.6592 5.14746 12.5273 5.20312 12.375 5.20312ZM9 5.20312C8.84766 5.20312 8.71582 5.14746 8.60449 5.03613C8.49316 4.9248 8.4375 4.79297 8.4375 4.64062C8.4375 4.3418 8.49316 4.05469 8.60449 3.7793C8.71582 3.50391 8.87988 3.26074 9.09668 3.0498L9.79102 2.34668C10.0137 2.12402 10.125 1.85742 10.125 1.54688C10.125 1.39453 10.1807 1.2627 10.292 1.15137C10.4033 1.04004 10.5352 0.984375 10.6875 0.984375C10.8398 0.984375 10.9717 1.04004 11.083 1.15137C11.1943 1.2627 11.25 1.39453 11.25 1.54688C11.25 1.8457 11.1943 2.13281 11.083 2.4082C10.9717 2.68359 10.8076 2.92676 10.5908 3.1377L9.89648 3.84082C9.67383 4.06348 9.5625 4.33008 9.5625 4.64062C9.5625 4.79297 9.50684 4.9248 9.39551 5.03613C9.28418 5.14746 9.15234 5.20312 9 5.20312ZM16.3125 6.75C16.5469 6.75 16.7666 6.79395 16.9717 6.88184C17.1768 6.96973 17.3555 7.08984 17.5078 7.24219C17.6602 7.39453 17.7803 7.57324 17.8682 7.77832C17.9561 7.9834 18 8.20312 18 8.4375V11.8125C18 12.0469 17.9561 12.2666 17.8682 12.4717C17.7803 12.6768 17.6602 12.8555 17.5078 13.0078C17.3555 13.1602 17.1768 13.2803 16.9717 13.3682C16.7666 13.4561 16.5469 13.5 16.3125 13.5H15.8115C15.7998 13.541 15.791 13.5791 15.7852 13.6143C15.7793 13.6494 15.7676 13.6846 15.75 13.7197V14.0625C15.75 14.4492 15.6768 14.8125 15.5303 15.1523C15.3838 15.4922 15.1816 15.791 14.9238 16.0488C14.666 16.3066 14.3672 16.5088 14.0273 16.6553C13.6875 16.8018 13.3242 16.875 12.9375 16.875H9.5625C9.10547 16.875 8.68359 16.7725 8.29688 16.5674C7.91016 16.3623 7.58789 16.0898 7.33008 15.75H2.93555C2.54883 15.75 2.18555 15.6768 1.8457 15.5303C1.50586 15.3838 1.20703 15.1846 0.949219 14.9326C0.691406 14.6807 0.489258 14.3818 0.342773 14.0361C0.196289 13.6904 0.123047 13.3242 0.123047 12.9375V12.375H2.37305C2.37305 11.9121 2.46094 11.4756 2.63672 11.0654C2.8125 10.6553 3.05566 10.2979 3.36621 9.99316C3.67676 9.68848 4.03418 9.44531 4.43848 9.26367C4.84277 9.08203 5.2793 8.99414 5.74805 9C5.92383 9 6.09375 9.01465 6.25781 9.04395C6.42188 9.07324 6.58594 9.11426 6.75 9.16699V5.625H15.75V6.75H16.3125ZM5.74805 10.125C5.4375 10.125 5.14746 10.1836 4.87793 10.3008C4.6084 10.418 4.36816 10.5791 4.15723 10.7842C3.94629 10.9893 3.78516 11.2266 3.67383 11.4961C3.5625 11.7656 3.50391 12.0586 3.49805 12.375H6.75V10.3711C6.59766 10.2949 6.43945 10.2363 6.27539 10.1953C6.11133 10.1543 5.93555 10.1309 5.74805 10.125ZM2.93555 14.625H6.81152C6.77051 14.4551 6.75 14.2676 6.75 14.0625V13.5H1.34473C1.40332 13.6641 1.48535 13.8135 1.59082 13.9482C1.69629 14.083 1.81641 14.2031 1.95117 14.3086C2.08594 14.4141 2.23828 14.4902 2.4082 14.5371C2.57812 14.584 2.75391 14.6133 2.93555 14.625ZM7.00488 15.2139V15.2227L7.01367 15.2402V15.2314L7.00488 15.2139ZM14.625 14.0625V6.75H7.875V14.0625C7.875 14.2969 7.91895 14.5166 8.00684 14.7217C8.09473 14.9268 8.21484 15.1055 8.36719 15.2578C8.51953 15.4102 8.69824 15.5303 8.90332 15.6182C9.1084 15.7061 9.32812 15.75 9.5625 15.75H12.9375C13.1719 15.75 13.3916 15.7061 13.5967 15.6182C13.8018 15.5303 13.9805 15.4102 14.1328 15.2578C14.2852 15.1055 14.4053 14.9268 14.4932 14.7217C14.5811 14.5166 14.625 14.2969 14.625 14.0625ZM16.875 11.8125V8.4375C16.875 8.28516 16.8193 8.15332 16.708 8.04199C16.5967 7.93066 16.4648 7.875 16.3125 7.875H15.75V12.375H16.3125C16.4648 12.375 16.5967 12.3193 16.708 12.208C16.8193 12.0967 16.875 11.9648 16.875 11.8125Z" fill="black" />
                    </svg> {getMealBasisExplanation(ris?.mb)}
                </span>

                {CancellationPolicy}

                {/* <div style={{ marginTop: 20 }}>
                    <h3 className='mb-2'>Cancellation Policy</h3>
                    {policies?.length > 0 && (
                        <>
                            <div style={{ marginBottom: 16 }}>
                                <Text strong>✅ Fully Refundable</Text>
                                <br />
                                <Text>Until: <strong>{new Date(policies?.[0]?.fdt).toLocaleString()}</strong></Text>
                                <br />
                                <Text type="success">💰 100% refund on cancellation</Text>
                            </div>

                            {policies?.map((policy, index) => (
                                <div key={index} style={{ marginBottom: 16 }}>
                                    <Text strong>
                                        {index === 0 ? '⚠️ Partially Refundable' : '❌ Non-Refundable'}
                                    </Text>
                                    <br />
                                    <Text>
                                        From: <strong>{new Date(policy?.fdt).toLocaleString()}</strong> <br />
                                        To: <strong>{new Date(policy?.tdt).toLocaleString()}</strong>
                                    </Text>
                                    <br />
                                    <Text type="danger">💸 ₹{policy?.am} will be charged on cancellation</Text>
                                </div>
                            ))}
                        </>
                    )}
                </div> */}

            </Modal>
        </>
    );
};

export default RoomDetailsModalTripjack;
